import React, { useContext, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import './Exam.css'
import Pause from "../../imgs/pause.png";
import Endtest from "../../imgs/endtest.png";
import Question from '../Question/Question';
import Globalcontext from '../../Context/Globalcontext';
import Dialog from '../Dialog/Dialog';
import Dialogpause from '../Dialogpause/Dialogpause';
import axios from 'axios';
import Dialogsolved from '../Dialogsolved/Dialogsolved';

const Exam = () => {
    const { state } = useLocation();
    const navigate = useNavigate();
    const a = useContext(Globalcontext);
    const [sectemp, setSectemp] = useState();
    const [resultsend, setResultsend] = useState();

    const min = 1;
    const max = 999;
    const rand = min + Math.random() * (max - min);


    useEffect(() => {
        const handleBeforeUnload = (e) => {
          e.preventDefault();
          e.returnValue = ''; // Chrome requires a returnValue to display a custom message
        };
    
        window.addEventListener('beforeunload', handleBeforeUnload);
    
        return () => {
          window.removeEventListener('beforeunload', handleBeforeUnload);
        };
      }, []);


    useEffect(() => {
        if (localStorage.getItem("gllogin") === '') {
            navigate('/studentiqtest');
        }
    })

    const [dialog, setDialog] = useState({
        message: "",
        isLoading: false,
        nameProduct: ""
    });

    const pausetest = () => {
        if (a.solutionflag == "false") {
            if (state.testname !== "Main Test") {
                handlepause("Test Paused", true, "");
            }
        }
    }

    const [dialogpause, setDialogpause] = useState({
        message: "",
        isLoading: false,
        nameProduct: ""
    });

    const handlepause = (message, isLoading, nameProduct) => {
        setDialogpause({
            message,
            isLoading,
            nameProduct
        });
    }

    const [dialogsolved, setDialogsolved] = useState({
        message: "",
        isLoading: false,
        nameProduct: ""
    });

    const handlesolved = (message, isLoading, nameProduct) => {
        setDialogsolved({
            message,
            isLoading,
            nameProduct
        });
    }

    const handleDialog = (message, isLoading, nameProduct) => {
        setDialog({
            message,
            isLoading,
            nameProduct
        });
    };

    const areUSure = (choose) => {
        if (choose) {
            handleDialog("", false);
        } else {
            handleDialog("", false);
        }
    };

    const areUSure2 = (choose) => {
        if (choose) {
            handlepause("", false);
        } else {
            handlepause("", false);
        }
    };

    const areUSure3 = (choose) => {
        if (choose) {
            handlesolved("", false);
        } else {
            handlesolved("", false);
        }
    };

    const Abort = () => {
        handleEnd();
    }

    const showsolved=()=>{
        handlesolved("Question Analysis", true, "");
    }


    const handleEnd = () => {
        a.setStatus("ended");
        a.setSeconds(59);
        a.setMinutes(29);
        a.setIndex(0);
        a.setCorrect(0);
        a.setAnasweredtemp(0);
        a.setElminutes(0);
        a.setElseconds(0);
        a.setSolutionflag("false");
        setempty();
    }

    const setempty = () => {
        a.setq1array({ "option": '', "correct": '' });
        a.setq2array({ "option": '', "correct": '' });
        a.setq3array({ "option": '', "correct": '' });
        a.setq4array({ "option": '', "correct": '' });
        a.setq5array({ "option": '', "correct": '' });
        a.setq6array({ "option": '', "correct": '' });
        a.setq7array({ "option": '', "correct": '' });
        a.setq8array({ "option": '', "correct": '' });
        a.setq9array({ "option": '', "correct": '' });
        a.setq10array({ "option": '', "correct": '' });
        a.setq11array({ "option": '', "correct": '' });
        a.setq12array({ "option": '', "correct": '' });
        a.setq13array({ "option": '', "correct": '' });
        a.setq14array({ "option": '', "correct": '' });
        a.setq15array({ "option": '', "correct": '' });
        a.setq16array({ "option": '', "correct": '' });
        a.setq17array({ "option": '', "correct": '' });
        a.setq18array({ "option": '', "correct": '' });
        a.setq19array({ "option": '', "correct": '' });
        a.setq20array({ "option": '', "correct": '' });

        a.setq1('');
        a.setq2('');
        a.setq3('');
        a.setq4('');
        a.setq5('');
        a.setq6('');
        a.setq7('');
        a.setq8('');
        a.setq9('');
        a.setq10('');
        a.setq11('');
        a.setq12('');
        a.setq13('');
        a.setq14('');
        a.setq15('');
        a.setq16('');
        a.setq17('');
        a.setq18('');
        a.setq19('');
        a.setq20('');

        navigate('/Dashboard');
    }

    window.onpopstate = () => {
        if (a.solutionflag == "false") {
            if (a.status == "ended") {
                navigate('/Test');
            }
            else if (a.status == "started") {
                navigate(1);
            }
        }
    }

    const handleClicknext = () => {

        if (a.index < 19) {
            a.setIndex(a.index + 1);
        
        }
    }

    const handleClickprev = () => {
        if (a.index >= 1) {
            a.setIndex(a.index - 1);
           
        }
    }

    const handlepointq = () => {
        console.log(a.cqueno);
      
    }

    const endtest = () => {
       
        if (a.solutionflag == "false") {
            handleDialog("End Test?", true, `Hey ${localStorage.getItem('glname')}, are you sure you want to end this exam?`);
        }
        else {
            if (state.testname === "Main Test") {
                if (localStorage.getItem("gllogin") === '') {
                    setresult();
                }
                else {
                    navigate(-1);
                }
            }
            else {
                setresult();
            }
        }
    }

    const setcorrect = (optiontemp, correcttemp) => {

        if (optiontemp !== undefined) {
            if (optiontemp !== "") {
                if (optiontemp === correcttemp) {
                    a.setCorrect(a.correct++);
                }
            }
            else if (optiontemp == "") {
                a.setAnasweredtemp(a.anasweredtemp++);
            }
        }
        else {
            a.setAnasweredtemp(a.anasweredtemp++);
        }
    }

    const setresult = async () => {
       
        await setAsyncTimeout(() => {
            setcorrect(a.q1array["option"], a.q1array["correct"]);
        }, 40);

        await setAsyncTimeout(() => {
            setcorrect(a.q2array["option"], a.q2array["correct"]);
        }, 40);

        await setAsyncTimeout(() => {
            setcorrect(a.q3array["option"], a.q3array["correct"]);
        }, 40);

        await setAsyncTimeout(() => {
            setcorrect(a.q4array["option"], a.q4array["correct"]);
        }, 40);
        await setAsyncTimeout(() => {
            setcorrect(a.q5array["option"], a.q5array["correct"]);
        }, 40);
        await setAsyncTimeout(() => {
            setcorrect(a.q6array["option"], a.q6array["correct"]);
        }, 40);
        await setAsyncTimeout(() => {
            setcorrect(a.q7array["option"], a.q7array["correct"]);
        }, 40);
        await setAsyncTimeout(() => {
            setcorrect(a.q8array["option"], a.q8array["correct"]);
        }, 40);
        await setAsyncTimeout(() => {
            setcorrect(a.q9array["option"], a.q9array["correct"]);
        }, 40);
        await setAsyncTimeout(() => {
            setcorrect(a.q10array["option"], a.q10array["correct"]);
        }, 40);
        await setAsyncTimeout(() => {
            setcorrect(a.q11array["option"], a.q11array["correct"]);
        }, 40);
        await setAsyncTimeout(() => {
            setcorrect(a.q12array["option"], a.q12array["correct"]);
        }, 40);
        await setAsyncTimeout(() => {
            setcorrect(a.q13array["option"], a.q13array["correct"]);
        }, 40);
        await setAsyncTimeout(() => {
            setcorrect(a.q14array["option"], a.q14array["correct"]);
        }, 40);
        await setAsyncTimeout(() => {
            setcorrect(a.q15array["option"], a.q15array["correct"]);
        }, 40);
        await setAsyncTimeout(() => {
            setcorrect(a.q16array["option"], a.q16array["correct"]);
        }, 40);
        await setAsyncTimeout(() => {
            setcorrect(a.q17array["option"], a.q17array["correct"]);
        }, 40);
        await setAsyncTimeout(() => {
            setcorrect(a.q18array["option"], a.q18array["correct"]);
        }, 40);
        await setAsyncTimeout(() => {
            setcorrect(a.q19array["option"], a.q19array["correct"]);
        }, 40);
        await setAsyncTimeout(() => {
            setcorrect(a.q20array["option"], a.q20array["correct"]);
        }, 40);


        if (a.correct <= 4) {
            a.setEstiscore(70);
        }
        else if (a.correct > 4 && a.correct <= 8) {
            a.setEstiscore(85);
        }
        else if (a.correct > 8 && a.correct <= 12) {
            a.setEstiscore(100);
        }
        else if (a.correct > 12 && a.correct <= 16) {
            a.setEstiscore(115);
        }
        else if (a.correct > 16 && a.correct <= 19) {
            a.setEstiscore(130);
        }
        else if (a.correct == 20) {
            a.setEstiscore(145);
        }

        a.setElminutes((30 - a.minutes) - 1);

        let rawData2 = {
            correct1: a.correct,
            anasweredtemp1: a.anasweredtemp,
            testname: state.testname,
            rand: rand
        }

        if (state.testname === "Main Test") {
            if (a.solutionflag == "false") {
                saveresult();
            }
            await setAsyncTimeout(() => {
                navigate('/Result', { state: rawData2 });
            }, 100);
        }
        else if (state.testname === "Demo Test") {
           
            if (a.solutionflag == "false") {
                saveresultdemo();
            }
            await setAsyncTimeout(() => {
                navigate('/Result', { state: rawData2 });
            }, 100);
        }
        else {
            await setAsyncTimeout(() => {
                navigate('/Result', { state: rawData2 });
            }, 100);
        }
    }

    const saveresult = () => {
        if (state.testname === "Main Test") {
         
            const attquestions = 20 - a.anasweredtemp;
            const etime = { minutes: a.minutes, seconds: a.seconds };
            let rawData = {
                mobno: localStorage.getItem("glmobno"),
                ayear: state.ayear,
                resultsend: JSON.stringify(a.mainresult),
                etime: JSON.stringify(etime),
                rand: Math.round(rand),
                maintest: "Yes",
                correct: a.correct,
                unattepted: a.anasweredtemp,
                minutes: ((30 - a.minutes) - 1) + " Min : " + (60 - a.seconds) + " Sec",
                seconds: (60 - a.seconds) + (((30 - a.minutes) - 1) * 60),
                milli: (((60 - a.seconds) + (((30 - a.minutes) - 1) * 60)) * 1000) + Math.round(rand),
                accuracy: Math.round((a.correct / 20) * 100) + "%",
                speed: Math.round(((60 - a.seconds) + (((30 - a.minutes) - 1) * 60)) / attquestions) + " Sec"
            }
            rawData = JSON.stringify(rawData)
            let formData = new FormData()
            formData.append('data', rawData);


            axios.post('https://softtesting.in/iniqtest/cust/studentpanel/updateresult.php', formData, {
                'Content-Type': 'multipart/form-data',

            }).then(function sample(response) {
               
                //   console.log("save res- ", response.data);
                localStorage.setItem('glresult', JSON.stringify(a.mainresult));
                localStorage.setItem('gletime', JSON.stringify(etime));
                localStorage.setItem('glrand', Math.round(rand));

            }).catch(err => {
                console.log(err);
            });
        }
    }

    const saveresultdemo = () => {
        if (state.testname === "Demo Test") {
            const attquestions = 20 - a.anasweredtemp;
            const etime = { minutes: a.minutes, seconds: a.seconds };
            let rawData = {
                mobno: localStorage.getItem("glmobno"),
                ayear: state.ayear,
                resultsend: JSON.stringify(a.mainresult),
                etime: JSON.stringify(etime),
                rand: Math.round(rand),
                maintest: "Yes",
                correct: a.correct,
                unattepted: a.anasweredtemp,
                minutes: ((30 - a.minutes) - 1) + " Min : " + (60 - a.seconds) + " Sec",
                seconds: (60 - a.seconds) + (((30 - a.minutes) - 1) * 60),
                milli: (((60 - a.seconds) + (((30 - a.minutes) - 1) * 60)) * 1000) + Math.round(rand),
                accuracy: Math.round((a.correct / 20) * 100) + "%",
                speed: Math.round(((60 - a.seconds) + (((30 - a.minutes) - 1) * 60)) / attquestions) + " Sec"
            }
            rawData = JSON.stringify(rawData)
            let formData = new FormData()
            formData.append('data', rawData);


            axios.post('https://softtesting.in/iniqtest/cust/studentpanel/updateresultdemo.php', formData, {
                'Content-Type': 'multipart/form-data',

            }).then(function sample(response) {
               
                  console.log("save res demo- ", response.data);
                localStorage.setItem('glresult', JSON.stringify(a.mainresult));
                localStorage.setItem('gletime', JSON.stringify(etime));
                localStorage.setItem('glrand', Math.round(rand));

            }).catch(err => {
                console.log(err);
            });
        }
    }

    const setAsyncTimeout = (cb, timeout = 0) => new Promise(resolve => {
        setTimeout(() => {
            cb();
            resolve();
        }, timeout);
    });

    let timer;
    useEffect(() => {
        if (a.solutionflag == "false") {
            timer = setInterval(() => {
                if (a.seconds > 1) {
                    a.setSeconds(a.seconds - 1);
                }
                if (a.seconds === 1) {
                    if (a.minutes >= 1) {
                        a.setMinutes(a.minutes - 1);
                        a.setSeconds(59);
                    }

                    if (a.minutes === 0) {
                        handleDialog("Time Finished?", true, `Hey ${localStorage.getItem('glname')}, are you sure you want to end this exam?`);
                    }
                }
            }, 1000)

            return () => clearInterval(timer);
        }
    });

    return (
        <div className='exam'>
            <div className="whitebox">
                <div className="header">
                    <div className="time">
                        <img onClick={pausetest} src={Pause} alt="" />
                        <span>{a.minutes} Minutes,{a.seconds} Seconds</span>
                    </div>
                    <div onClick={showsolved} className="end aa">
                        <span>{a.solutionflag == "false" ? ("Solved : " +  (a.calcsolved())) : "Solved : " +  (20 - a.tempunanswer) }</span>
                        <span>{a.solutionflag == "false" ? (", Unsolved : " + (20 - a.calcsolved())) : ", Unsolved : " + a.tempunanswer}</span>
                    </div>
                    <div onClick={endtest} className="end bb">
                        <img src={Endtest} alt="" />
                        <span>{a.solutionflag === 'false' ? `End Test` : `View Result`}</span>
                    </div>
                </div>

                <Question testname={state.testname} language={state.language1} DataSource={state.DataSource[a.index]} index={a.index} />

                <div className="np">
                    <div onClick={handleClickprev} className="headprev">
                        {'<'} Previous
                    </div>
                    <div onClick={handleClicknext} className="headprev">
                        Next {'>'}
                    </div>
                </div>
            </div>
            {dialog.isLoading && (
                <Dialog
                    //Update
                    submessage={dialog.nameProduct}
                    onDialog={areUSure}
                    message={dialog.message}
                    functionname={setresult}
                    button1text="END TEST"
                    button2text="Cancel"
                />
            )}

            {dialogpause.isLoading && (
                <Dialogpause
                    //Update
                    submessage={dialogpause.nameProduct}
                    onDialog={areUSure2}
                    message={dialogpause.message}
                    functionname={Abort}
                    button1text="END TEST"
                    button2text="Cancel"
                />
            )}

            {dialogsolved.isLoading && (
                <Dialogsolved
                    //Update
                    submessage={dialogsolved.nameProduct}
                    onDialog={areUSure3}
                    message={dialogsolved.message}
                    functionname={handlepointq}
                    button1text="OK"
                    button2text="Cancel"
                 
                />
            )}
        </div>
    )
}
export default Exam
